import React from 'react';
import { Combo } from 'fw/forms';
import * as API from 'modules/app/API'

class AuditActionCombo extends React.PureComponent {
    constructor(props) {
        super(props);
        this.state = {};
        this._isMounted = false;
    }

	componentDidMount = () => {
		this._isMounted = true;

        API.Audit.get('/getActions', {},
        {
            success: (r) => {
                this._isMounted && this.setState({
                    items: r.data.items.map((item) => { return { label: item.actionName, value: item.actionCode } })
                 });
            }
        }, { block: false });
	}

	componentWillUnmount() {
		this._isMounted = false;
	}

    render() {
        return (
            <Combo
                {...this.props}
                items={this.state.items}
                searchable={true} />
        )
    }
}

export default AuditActionCombo;

// Mark this as a form component
AuditActionCombo.defaultProps = {
    formControl: true,
    managed: false
};



// WEBPACK FOOTER //
// ./src/areas/shared/controls/auditActionCombo/AuditActionCombo.js